var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{attrs:{"color":_vm.bloqueado === _vm.valor ? 'red' : 'green'}},[_vm._v(" "+_vm._s(_vm.bloqueado === _vm.valor ? 'block' : 'check')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }